import Vue from 'vue';
import Vuex from 'vuex'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import CKEditor from 'ckeditor4-vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import store from './store';

import router from './routes/router';
import './routes/filter'


Vue.use(Vuex)
Vue.use(DashboardPlugin);
Vue.use(VueSweetalert2);
import './filter.js'
Vue.use(CKEditor);
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  mounted() {
    this.$store.dispatch('loadUser')
  }
});
